import React from 'react';

const Clause = ({ children }) => <div className="clause">{children}</div>;

export default Clause;
